import { Button, locationReload } from '@ytl/common-web';
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useLanguage } from '../contexts/languageContext';
import { useOpenAm } from '../contexts/openAmContext';
import { StageFailureType } from '../shared/@types/OpenAmStage';
import { useOpenAmStage } from '../shared/services/useOpenAmStage';

export const LoginYoloOtpState = () => {
  const { translation } = useLanguage();
  const { isLoading, stage } = useOpenAm();
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const otpInput = useRef<HTMLInputElement>(null);

  const { loginWithOtpCode, reSendOtp } = useOpenAmStage();

  const parsed = JSON.parse(stage.infoText?.at(0) || '{}');
  const confirmYoloOTP = useCallback(
    async (otpCode: string) => {
      try {
        setError('');
        await loginWithOtpCode(otpCode, failure => {
          if (failure.stagefailure === StageFailureType.YolootpInvalidCode) {
            setError(translation.loginRegister.otp.invalidCode);
          }
        });
      } catch (err) {
        setError(translation.loginRegister.otp.invalidCode);
      }
    },
    [setError, translation, loginWithOtpCode],
  );

  const updateOtp = useCallback(
    (value: string) => {
      setOtp(value);
      setError('');
      if (value.length === 6) {
        confirmYoloOTP(value);
      }
    },
    [setOtp, confirmYoloOTP],
  );

  const sendAgainClicked = useCallback(() => {
    setOtp('');
    setError('');
    reSendOtp(_res => {});
  }, [setOtp, reSendOtp]);

  useLayoutEffect(() => {
    (global as any).$enterOtpCode = (code: string) => {
      updateOtp(code);
    };
  }, [updateOtp]);

  useEffect(() => {
    if (otpInput.current) {
      otpInput.current.focus();
    }
  }, []);

  return (
    <>
      <h3>{translation.loginRegister.otp.header}</h3>

      <div className={'login-page__mfa-wrapper login-page__mfa-wrapper--yolo-otp'}>
        <p
          dangerouslySetInnerHTML={{
            __html: translation.loginRegister.otp.desc(parsed.accountEmail),
          }}
        ></p>
        <div className="login-page__mfa-wrapper--yolo-otp--email-button-container">
          <Button
            type="button"
            className="button button--text"
            onClick={() => locationReload()}
          >
            {translation.loginRegister.otp.changeEmail}
          </Button>
        </div>
        <div className={`form-input otp-code-input ${!!error ? 'otp-code-input--error' : ''}`}>
          <div
            className="otp-code-input__value"
            onClick={() => otpInput.current?.focus()}
          >
            <span>{otp.charAt(0) || ''}</span>
            <span>{otp.charAt(1) || ''}</span>
            <span>{otp.charAt(2) || ''}</span>
            <span>{otp.charAt(3) || ''}</span>
            <span>{otp.charAt(4) || ''}</span>
            <span>{otp.charAt(5) || ''}</span>
          </div>
          <input
            ref={otpInput}
            value={otp}
            onChange={e => updateOtp(e.target.value)}
            type="number"
            pattern={'[0-9]*'}
            aria-label={translation.accessibility.code}
          />
        </div>

        {error && <div className="login-page__mfa-wrapper__error">{error}</div>}

        <Button
          variant={'text-undecorated'}
          onClick={sendAgainClicked}
          disabled={isLoading}
        >
          {translation.loginRegister.otp.sendAgain}
        </Button>
      </div>
    </>
  );
};
